module.exports = __webpack_public_path__ + "static/media/atl_logo_cropped_circle.82fa8e9a.png";